import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Toasted from "vue-toasted";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue } from "bootstrap-vue";
Vue.config.productionTip = false

Vue.component("v-select", vSelect);
Vue.use(BootstrapVue);
Vue.use(Toasted, {  
	iconPack: "fontawesome",
	singleton: true,
});
new Vue({
  router,
  store,
  created() {
    const token = localStorage.getItem('userToken');
    if (token && this.$route.path !== '/user/support') {
      this.$router.push('/user/support');
    }
  },
  render: h => h(App)
}).$mount('#app')
